import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import PollCard from "../components/PollCard";
import api from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

const MyPollsPage = () => {
  const navigate = useNavigate();
  const [createdPolls, setCreatedPolls] = useState([]);
  const [votedPolls, setVotedPolls] = useState([]);

  const fetchPolls = async () => {
    try {
      const [createdResponse, votedResponse] = await Promise.all([
        api.get("/users/me/polls/created"),
        api.get("/users/me/polls/voted"),
      ]);
      setCreatedPolls(createdResponse.data);
      setVotedPolls(votedResponse.data);
    } catch (error) {
      toast.error("Unable to load your polls.");
    }
  };

  useEffect(() => {
    fetchPolls();
  }, []);

  const updateCreatedPoll = (updatedPoll) => {
    setCreatedPolls((prev) => prev.map((poll) => (poll.id === updatedPoll.id ? updatedPoll : poll)));
  };

  const updateVotedPoll = (updatedPoll) => {
    setVotedPolls((prev) => prev.map((poll) => (poll.id === updatedPoll.id ? updatedPoll : poll)));
  };

  const removePoll = (pollId) => {
    setCreatedPolls((prev) => prev.filter((poll) => poll.id !== pollId));
    setVotedPolls((prev) => prev.filter((poll) => poll.id !== pollId));
  };

  return (
    <div className="space-y-6" data-testid="my-polls-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-2xl font-semibold" data-testid="my-polls-title">
            My Polls
          </h2>
          <p className="text-sm text-muted-foreground" data-testid="my-polls-subtitle">
            Track the polls you created and voted on.
          </p>
        </div>
        <Button onClick={() => navigate("/create")} data-testid="my-polls-create-button">
          Create poll
        </Button>
      </div>

      <Tabs defaultValue="created" className="w-full" data-testid="my-polls-tabs">
        <TabsList className="grid w-full grid-cols-2" data-testid="my-polls-tabs-list">
          <TabsTrigger value="created" data-testid="my-polls-created-tab">
            Created
          </TabsTrigger>
          <TabsTrigger value="voted" data-testid="my-polls-voted-tab">
            Voted
          </TabsTrigger>
        </TabsList>
        <TabsContent value="created" className="mt-4" data-testid="my-polls-created-panel">
          <div className="space-y-7">
            {createdPolls.length === 0 ? (
              <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" data-testid="my-polls-created-empty">
                You haven't created a poll yet.
              </div>
            ) : (
              createdPolls.map((poll) => (
                <PollCard key={poll.id} poll={poll} onUpdate={updateCreatedPoll} onRemove={removePoll} />
              ))
            )}
          </div>
        </TabsContent>
        <TabsContent value="voted" className="mt-4" data-testid="my-polls-voted-panel">
          <div className="space-y-7">
            {votedPolls.length === 0 ? (
              <div className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" data-testid="my-polls-voted-empty">
                You haven't voted on any polls yet.
              </div>
            ) : (
              votedPolls.map((poll) => (
                <PollCard key={poll.id} poll={poll} onUpdate={updateVotedPoll} onRemove={removePoll} />
              ))
            )}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default MyPollsPage;
